import React, { useEffect, useState, useContext } from 'react';
import {
    Card,
    Button,
    Image,
    Spinner,
    Modal,
    Alert,
    Badge
} from 'react-bootstrap';
import {
    Link
} from "react-router-dom";
import { faAward, faVideo, faUsers, faChalkboardTeacher, faLightbulb, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AcademyNavbar from '../Academy/AcademyNavbar';
import AcademyFooter from '../Academy/AcademyFooter';
import firebase from 'firebase';
import { library } from '@fortawesome/fontawesome-svg-core';
import DashboardNavbar from '../Dashboard/DashboardNavbar';

library.add(faAward, faVideo, faUsers, faChalkboardTeacher, faLightbulb, faArrowRight);


const SelectProgram = (props) => {
    const [tempProgramList, setTempProgramList] = useState([]);
    const [tempUsers, setTempUsers] = useState([]);
    // Getting temp programs
    useEffect(() => {
        firebase.firestore().collection('/Variants/pt-BR/programList/').get()
        .then(snapshot => {
            let tempProgramList = [];
            snapshot.forEach(doc => {
                tempProgramList.push(doc.data());
            });
            setTempProgramList(tempProgramList);
        })
    }, [])

    // Getting users
    useEffect(() => {
        firebase.firestore().collection('academyUsers').get()
        .then(snapshot => {
            let tempUsersList = [];
            snapshot.forEach(doc => {
                tempUsersList.push({id: doc.id, ...doc.data()});
            });
            setTempUsers(tempUsersList);
        })
    }, [])

    const getCreatedByUserInfo = (id) => {
        let name ='';
        tempUsers.map((user) => {
            if(user.id === id){
                name = `${user.firstName} ${user.lastName}`;
            }
        })
        return name;
    }

    const viewProgramHandler = (slug) => {
        props.history.push({pathname: `/admin/viewprogram/${slug}`})
    }

    const getPDFProgramHandler = (slug) => {
        props.history.push({pathname: `/admin/programpdf/${slug}`})
    }

    const editProgramHandler = (slug) => {
        props.history.push({pathname: `/admin/programcardeditor/${slug}`})
    }


    return (
        <>
            <DashboardNavbar />
            <div className="container">
                <h3 className="text-white mt-3 mb-3">Referrals</h3>
                <table class="table table-responsive-md table-hover table-dark">
                <thead>
                    <tr className="text-center">
                    <th scope="col">#</th>
                    <th scope="col">ProgramName</th>
                    <th scope="col">Program ID</th>
                    <th scope="col">Created By</th>
                    {/* <th scope="col">PDF</th> */}
                    <th scope="col">View Program</th>
                    <th scope="col">Edit Program</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        tempProgramList.map((tempProgram, index) =>{
                            return(
                                <tr className="text-center">
                                <th scope="row" className="align-middle">{index + 1}</th>
                                <td className="align-middle w-25">{tempProgram.programTitle}</td>
                                <td className="align-middle">{tempProgram.programId}</td>
                                <td className="align-middle">{getCreatedByUserInfo(tempProgram.createdBy)}</td>
                                {/* <td className="align-middle"><Button variant="primary" onClick={() => getPDFProgramHandler(tempProgram.programSlug)} >PDF</Button></td> */}
                                <td className="align-middle"><Button variant="primary" className="btn-sm" onClick={() => viewProgramHandler(tempProgram.programSlug)}>View Program</Button></td>
                                <td className="align-middle"><Button variant="warning" className="btn-sm" onClick={() => editProgramHandler(tempProgram.programSlug)} >Edit Program</Button></td>
                                </tr>
                            )
                        })
                    }
                </tbody>
                </table>
            </div>
            <AcademyFooter />
        </>
    );
}


export default SelectProgram;
